export async function getDeviceInfo() {
    const ua = navigator.userAgent;
    const isMobile = /Mobi|Android|iPhone|iPad|Mobile/i.test(ua);
    const deviceType = isMobile ? 'Mobile' : 'Computer';
    const os = await detectOS(ua);
    const browser = detectBrowser(ua);

    return {
        deviceType,
        os,
        browser
    };
}

export async function detectOS(ua) {
    // 1. Use userAgentData if supported (Chromium browsers) --> only reliable way to see if windows 11
    if (navigator.userAgentData?.getHighEntropyValues) {
        try {
            const data = await navigator.userAgentData.getHighEntropyValues([
                "platform", "platformVersion"
            ]);

            if (data.platform === "Windows") {
                const version = parseFloat(data.platformVersion);
                return version >= 13 ? "Windows 11" : "Windows 10";
            }

            return `${data.platform} ${data.platformVersion}`;
        } catch (err) {
            console.warn("High-entropy OS detection failed:", err);
        }
    }

    const osRules = [
        {
            regex: /Windows NT 10\.0/,
            name: uaString => (/Windows 11/.test(uaString) ? 'Windows 11' : 'Windows 10') // Not as reliable as first method to find windows 11, but its a fallback
        },
        { regex: /Windows NT 6.3/, name: 'Windows 8.1' },
        { regex: /Windows NT 6.2/, name: 'Windows 8' },
        { regex: /Windows NT 6.1/, name: 'Windows 7' },
        { regex: /Windows NT 6.0/, name: 'Windows Vista' },
        { regex: /Windows NT 5.1/, name: 'Windows XP' },
        {
            regex: /Mac OS X (\d+[_\.]\d+)/,
            name: m => `macOS ${m[1].replace(/_/g, '.')}`
        },
        {
            regex: /Android (\d+[\.\d]*)/,
            name: m => `Android ${m[1]}`
        },
        {
            regex: /iPhone OS (\d+[_\.]\d+)/,
            name: m => `iOS ${m[1].replace(/_/g, '.')}`
        },
        {
            regex: /iPad; CPU OS (\d+[_\.]\d+)/,
            name: m => `iPadOS ${m[1].replace(/_/g, '.')}`
        },
        { regex: /Linux/, name: 'Linux' },
        { regex: /CrOS/, name: 'Chrome OS' }
    ];

    const os = await detectFromRules(osRules, ua, null);

    // Heuristic fallback if nothing matched
    if (!os) {
        if (/Android/i.test(ua)) return 'Android';
        if (/iPhone/i.test(ua)) return 'iOS';
        if (/iPad/i.test(ua)) return 'iPadOS';
        if (/Windows/i.test(ua)) return 'Windows';
        if (/Mac/i.test(ua)) return 'macOS';
        if (/Linux/i.test(ua)) return 'Linux';
    }

    return os || 'Unknown OS';
}

export async function detectFromRules(rules, uaString, fallback) {
    for (const rule of rules) {
        const match = uaString.match(rule.regex);
        if (match) {
            if (typeof rule.name === 'function') {
                return rule.name(uaString, match); // Pass both ua and match to the function
            }
            return rule.name;
        }
    }
    return fallback;
}

export function detectBrowser(ua) {
    const browserRules = [
        { regex: /Edg\/(\d+)/, name: m => `Edge ${m[1]}` },
        { regex: /Chrome\/(\d+)/, name: m => `Chrome ${m[1]}` },
        { regex: /Firefox\/(\d+)/, name: m => `Firefox ${m[1]}` },
        { regex: /Version\/(\d+).+Safari/, name: m => `Safari ${m[1]}` },
    ];

    for (const rule of browserRules) {
        const match = ua.match(rule.regex);
        if (match) return rule.name(match);
    }
    return "Unknown Browser";
}